"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveAnnouncer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _VisuallyHidden = require("./VisuallyHidden");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LIVEREGION_TIMEOUT_DELAY = 7000;
var counter = 0;
/**
 * TODO: LiveAnnouncer should be a singleton.
 */

var LiveAnnouncer = /*#__PURE__*/(0, _react.forwardRef)(function LiveAnnouncer(_, ref) {
  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      logs = _useState2[0],
      setLogs = _useState2[1];

  var announce = (0, _react.useCallback)(function (message) {
    var assertiveness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assertive';
    setLogs(function (logs) {
      counter++;
      return [].concat(_toConsumableArray(logs), [{
        assertiveness: assertiveness,
        id: counter,
        message: message
      }]);
    });
    setTimeout(function () {
      setLogs(function (logs) {
        var newLogs = _toConsumableArray(logs);

        newLogs.shift();
        return newLogs;
      });
    }, LIVEREGION_TIMEOUT_DELAY);
  }, []);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      announce: announce
    };
  }, [announce]);
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, {
    liveAnnouncer: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-live": "assertive",
    "aria-relevant": "additions",
    role: "log"
  }, logs.filter(function (log) {
    return log.assertiveness === 'assertive';
  }).map(function (log) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: log.id
    }, log.message);
  })), /*#__PURE__*/_react.default.createElement("div", {
    "aria-live": "polite",
    "aria-relevant": "additions",
    role: "log"
  }, logs.filter(function (log) {
    return log.assertiveness === 'polite';
  }).map(function (log) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: log.id
    }, log.message);
  }))), document.body);
});
exports.LiveAnnouncer = LiveAnnouncer;